module.exports = __webpack_public_path__ + "static/media/icon_location.422ad110.svg";